<template>
  <ModalSheet :aria-label="title || 'Store questions'" :content-key="contentKey" footer-id="question-modal-footer">
    <div v-if="questionCount > 1" class="text-xs font-semibold uppercase tracking-wide text-gray-brand-500 mb-2">
      Question {{ questionNumber }} of {{ questionCount }}
    </div>
    <div class="text-xl font-bold text-gray-brand-900 tracking-tighter">
      {{ title }}
    </div>
    <h3 v-if="subtitle" class="mt-1 text-md text-gray-brand-700 w-full whitespace-pre-line">
      {{ subtitle }}
    </h3>
    <slot />
  </ModalSheet>
</template>

<script>
import ModalSheet from '@/components/Molecules/ModalSheet.vue'

export default {
  name: 'QuestionModal',

  components: {
    ModalSheet
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    questionNumber: {
      type: Number,
      default: 1
    },
    questionCount: {
      type: Number,
      default: 1
    },
    contentKey: {
      type: [String, Number],
      default: 0
    }
  },

  // QuestionFooterButtons injects this to decide between teleporting into #question-modal-footer and
  // rendering its buttons in place on the checkout page.
  provide() {
    return { inQuestionModal: true }
  }
}
</script>
